export default {
    debug: true,
    state: {
        audioElements: {
            data: {},
            required: true
        },
        stopListners: {
            data: {},
            required: true
        }
    },
    loadAudioElement: function (audioItem, url) {
        let audioElement
        const audioElements = this.state.audioElements.data
        if (!(audioItem.buttonId in audioElements)) {
            audioElement = new Audio(url)
            audioElement.load()
            audioElements[audioItem.buttonId] = audioElement
        } else {
            audioElement = audioElements[audioItem.buttonId]
        }

        return audioElement
    },
    getAudioElements: function () {
        return this.state.audioElements.data
    },
    getAllStopListner: function () {
        return this.state.stopListners.data
    },
    removeStopListner: function (funcId) {
        delete this.state.stopListners.data[funcId]
    },
    setStopListner: function (funcId, stopListner) {
        this.state.stopListners.data[funcId] = stopListner
    },
    clearAllListners: function () {
        this.state.stopListners.data = {}
    }
}
